//
//
//
//

import wx from "weixin-js-sdk"
import global_ from "./global";

export default {
  name: "bondaccount",
  async created() {
    const {data} = await this.$http.get('/api/v1/wechat/' + localStorage.getItem('openid') + '/Info')
    if (!data.subscribe) {
      this.$router.push({name: "attention"})
      return;
    }
    this.$http.post('/api/v1/wechat/bond_account',{
          userid : this.$route.query.userid,
          state : new Date().getTime(),
          name : this.$route.query.name,
          otp:'official',
          openid : localStorage.getItem('openid'),
          unionid:localStorage.getItem('unionid'),
          nickname:localStorage.getItem('nickname'),
          imgurl:localStorage.getItem('imgurl')
      }).then(() => {
      alert('绑定成功')
      wx.closeWindow()
    }).catch(error => {
      this.$vux.alert.show({
        content: JSON.parse(error.response.data.error_message).zh_string,
        onHide: () => {
          wx.closeWindow()
        }
      })
    })
  },
  mounted() {
    setTimeout(() => {
      const timestamp = parseInt(new Date().getTime() / 1000)
      const u = navigator.userAgent
      const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
      this.$http.get('static/config.json').then(response => {
        const config = response.data
        const url = isiOS ? config.host + global_.entryUrl : config.host + this.$route.fullPath;
        const noncestr = Math.random().toString(36).substr(2)
        this.$http.get('/api/v1/wechat/jsApiTicket?timestamp=' + timestamp + '&noncestr=' + noncestr + '&url=' + encodeURIComponent(url))
          .then((response) => {
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: config.appId, // 必填，公众号的唯一标识
              timestamp: timestamp, // 必填，生成签名的时间戳
              nonceStr: noncestr, // 必填，生成签名的随机串
              signature: response.data, // 必填，签名
              jsApiList: ['checkJsApi'] // 必填，需要使用的JS接口列表
            })
            wx.error(function (res) {
              // alert(res.errMsg)
            })
            wx.ready(() => {
            })
          })
          .catch((error) => {
            alert('服务器错误，请稍后重试')
            if (error.response) {
              console.log(error.response.data)
            } else if (error.request) {
              console.log(error.request)
            } else {
              console.log('Error', error.message)
            }
          })
      }, response => {
        console.log('数据加载失败')
      })
    }, 500)
  },
}



// WEBPACK FOOTER //
// ./src/components/bondaccount.vue